// src/hooks/useCart.js
import { useState } from 'react';

const useCart = () => {
    const [basket, setBasket] = useState(() => {
        const savedBasket = localStorage.getItem('basket');
        return savedBasket ? JSON.parse(savedBasket) : [];
    });

    const updateBasket = (newBasket) => {
        localStorage.setItem('basket', JSON.stringify(newBasket));
        setBasket(newBasket);
    };

    // Modified to accept price parameter
    const increment = (id, price, showToast) => {
        const currentBasket = getLocalBasket();
        console.log('Current Basket:', currentBasket);
        const existingItem = currentBasket.find(item => item.id === id);
        let newBasket;

        if (existingItem) {
            if (showToast) showToast('Item added to cart!');
            newBasket = currentBasket.map(item =>
                item.id === id ? { ...item, quantity: item.quantity + 1 } : item
            );
        } else {
            if (showToast) showToast('Item added to cart!');
            // Store the price at the time of adding to cart
            newBasket = [...currentBasket, { id, quantity: 1, price }];
        }

        updateBasket(newBasket);
    };

    const getLocalBasket = () => {
        const savedBasket = localStorage.getItem('basket');
        return savedBasket ? JSON.parse(savedBasket) : [];
    };

    const decrement = (id, showToast) => {
        if (showToast) showToast('Item removed from cart!');
        const currentBasket = getLocalBasket();

        const newBasket = currentBasket
            .map(item =>
                item.id === id ? { ...item, quantity: Math.max(0, item.quantity - 1) } : item
            )
            .filter(item => item.quantity > 0);

        updateBasket(newBasket);
    };

    const remove = (id, showToast) => {
        if (showToast) showToast('Item removed from cart!');
        const currentBasket = getLocalBasket();
        const newBasket = currentBasket.filter(item => item.id !== id);
        updateBasket(newBasket);
    };

    const clearCart = () => {
        updateBasket([]);
    };

    const getTotalItems = () => {
        return basket.reduce((total, item) => total + item.quantity, 0);
    };

    // Simplified - now uses the stored price instead of recalculating
    const getTotalAmount = () => {
        const currentBasket = getLocalBasket();
        return currentBasket.reduce((total, item) => {
            return total + (item.price * item.quantity);
        }, 0);
    };

    return {
        basket,
        increment,
        decrement,
        remove,
        clearCart,
        getTotalItems,
        getTotalAmount
    };
};

export default useCart;